import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export interface RankingUser {
  id: string;
  student_name: string;
  cerebrix: number;
  cerebrix_level: number;
  current_badge: string;
  current_badge_icon: string;
  rank: number;
  lesson_level: string;
}

export function useGlobalRanking() {
  const { user } = useAuth();

  const { data: ranking, isLoading } = useQuery({
    queryKey: ['globalRanking'],
    queryFn: async () => {
      // Obtener el top 10 de usuarios
      const { data: topUsers, error: topError } = await supabase
        .from('user_progress_details')
        .select('*')
        .order('cerebrix', { ascending: false })
        .limit(10);

      if (topError) throw topError;

      // Obtener la posición del usuario actual si no está en el top 10
      if (user) {
        const { count: betterUsers } = await supabase
          .from('user_progress_details')
          .select('*', { count: 'exact', head: true })
          .filter('cerebrix', 'gt', user.cerebrix);

        const userRank = (betterUsers || 0) + 1;

        // Si el usuario no está en el top 10, obtener sus datos
        if (!topUsers.find(u => u.id === user.id)) {
          const { data: userData } = await supabase
            .from('user_progress_details')
            .select('*')
            .eq('id', user.id)
            .single();

          if (userData) {
            userData.rank = userRank;
          }

          return {
            topUsers: topUsers.map((u, i) => ({ ...u, rank: i + 1 })),
            currentUser: userData
          };
        }
      }

      return {
        topUsers: topUsers.map((u, i) => ({ ...u, rank: i + 1 })),
        currentUser: null
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutos
  });

  return {
    ranking,
    isLoading
  };
}
